/**
 * Müşteri seçiminin seçenek listesi (Ürün Sahibi, 09.10.2026: yeni oluşturulan kişi teklifte seçili gelsin).
 *
 * Kök neden: ekrandaki liste sunucudan ada göre sıralı ilk 50 kayıt (ya da arama sonucu 20). Üretimde
 * 1.500'den fazla müşteri var; yeni kişi o ilk 50'ye girmeyince `customerId` doğru atanıyordu ama
 * `<select>` seçeneği bulamayıp boş görünüyordu ve satışçı kişiyi yeniden yazıp seçiyordu.
 * Seçili müşteri listede yoksa listenin başına eklenir; varsa liste olduğu gibi döner.
 */
export function musteriSecenekleri<T extends { id: string }>(liste: readonly T[], secili: T | null | undefined, seciliId: string): T[] {
  if (!secili || secili.id !== seciliId || liste.some(musteri => musteri.id === seciliId)) return [...liste];
  return [secili, ...liste];
}

/** Seçici arama uçları: `liste` portföy (boş sorgu), `ara` bütün müşteri tabanı (sorgu var). */
export interface MusteriIstemcisi<T> {
  liste: (params: { pageSize: number; sort: string; direction: string }) => Promise<{ items: T[] }>;
  ara: (q: string) => Promise<{ items: T[] }>;
}

/**
 * Satış müşteri seçici (P1, 09.10.2026). Sorgu varken `/customers` (CRM_SALES'te yalnız kendi
 * portföyü) değil, sınırlı `/customers/search` çağrılır: satışçı başkasının portföyündeki mevcut
 * müşteriyi adıyla bulup seçebilsin. Tek harf aramaya gitmez (sunucu en az 2 karakter ister);
 * sorgu boş ya da tek harfliyse ada göre ilk 50 portföy listesi gelir.
 */
export async function musteriAra<T>(sorgu: string, istemci: MusteriIstemcisi<T>): Promise<{ items: T[] }> {
  const q = sorgu.trim();
  if (q.length >= 2) return istemci.ara(q);
  return istemci.liste({ pageSize: 50, sort: 'displayName', direction: 'asc' });
}
